import { http, HttpResponse } from 'msw'
import {
  BuyerProposalDetailDto,
  CreateProposalDto,
  FileType,
  FileUploadResponse,
  IssuerProposalOverviewDto,
  Proposal,
  ProposalCreationResponse,
  ProposalStatus,
  ScheduleType,
} from '../components/shared/types'
import { v4 as uuidv4 } from 'uuid'

const mswMockIssuerProposalOverviews: IssuerProposalOverviewDto[] = [
  {
    proposalId: 'msw-issuer-prop-001',
    buyerTenantName: 'MSW Buyer Default',
    fund: 'MSW Issuer Fund (Default View)',
    bidDeadline: '2025-06-19T14:09:00.000Z',
    depositAmount: 500000,
    depositDate: '2025-06-21T00:00:00.000Z',
    statusSummary: 'Active - awaiting bid',
    createdAt: '2025-06-15T10:00:00.000Z',
  },
  {
    proposalId: 'msw-issuer-prop-002',
    buyerTenantName: 'Another MSW Buyer',
    fund: 'Tech Growth Fund (MSW Issuer)',
    bidDeadline: '2025-06-24T14:09:00.000Z',
    depositAmount: 750000,
    depositDate: '2025-06-28T00:00:00.000Z',
    statusSummary: 'Completed - bid won',
    createdAt: '2025-06-18T09:30:00.000Z',
  },
]

export const mockIssuerProposals: Proposal[] = [
  {
    id: 'msw-issuer-prop-001',
    buyerTenantName: 'MSW Buyer Default',
    fund: 'MSW Issuer Fund (Default View)',
    depositAmount: 500000,
    depositDate: '2025-06-21T00:00:00.000Z',
    bidDeadline: '2025-06-19T14:09:00.000Z',
    scenarios: [
      {
        id: 'msw-scenario-1',
        proposedRate: 3.125,
        wamYears: 4.5,
        paymentSchedule: [
          {
            payoutAmount: 0,
            payoutPercentage: 40,
            paymentDate: '2025-08-15T12:00:00.000Z',
          },
          {
            payoutAmount: 0,
            payoutPercentage: 60,
            paymentDate: '2025-12-20T12:00:00.000Z',
          },
        ],
        bids: [],
        selectedBids: [],
      },
      {
        id: 'msw-scenario-2',
        proposedRate: 3.875,
        wamYears: 6.25,
        paymentSchedule: [
          {
            payoutAmount: 0,
            payoutPercentage: 100,
            paymentDate: '2025-10-30T12:00:00.000Z',
          },
        ],
        bids: [],
        selectedBids: [],
      },
    ],
    issuerTenantIds: ['issuer-tenant-1'],
    status: ProposalStatus.ACTIVE,
    files: [
      { id: 'msw-file-001', name: 'proposal-details.pdf' },
      { id: 'msw-file-002', name: 'investment-terms.docx' },
      { id: 'msw-file-003', name: 'final-agreement.pdf' },
    ],
    createdAt: '2025-06-01T10:00:00.000Z',
  },
  {
    id: 'msw-issuer-prop-002',
    buyerTenantName: 'Another MSW Buyer',
    fund: 'Tech Growth Fund (MSW Issuer)',
    depositAmount: 750000,
    depositDate: '2025-06-28T00:00:00.000Z',
    bidDeadline: '2025-06-24T14:09:00.000Z',
    scenarios: [
      {
        id: 'msw-scenario-3',
        proposedRate: 4.25,
        wamYears: 5.75,
        paymentSchedule: [
          {
            payoutAmount: 0,
            payoutPercentage: 25,
            paymentDate: '2025-09-01T12:00:00.000Z',
          },
          {
            payoutAmount: 0,
            payoutPercentage: 35,
            paymentDate: '2025-11-15T12:00:00.000Z',
          },
          {
            payoutAmount: 0,
            payoutPercentage: 40,
            paymentDate: '2026-01-30T12:00:00.000Z',
          },
        ],
        bids: [
          {
            id: 'msw-bid-1',
            issuerTenantId: 'issuer-tenant-1',
            rate: 4.125,
            treasuryRate: 3.95,
            notes: 'Competitive rate with favorable terms',
            status: null,
            createdAt: '2025-06-20T09:30:00.000Z',
          },
          {
            id: 'msw-bid-2',
            issuerTenantId: 'issuer-tenant-1',
            rate: 4.375,
            treasuryRate: 4.15,
            notes: 'Additional terms for higher rate',
            status: null,
            createdAt: '2025-06-20T11:15:00.000Z',
          },
        ],
        selectedBids: [
          {
            selectedBidId: 'selected-bid-msw-1',
            issuerTenantId: 'issuer-tenant-1',
            rate: 4.125,
            treasuryRate: 3.95,
            amount: 750000,
            wamYears: 5.75,
            partialMaturities: [
              {
                paymentDate: '2025-09-01T12:00:00.000Z',
                amount: 187500,
                inputType: 'DOLLAR',
              },
              {
                paymentDate: '2025-11-15T12:00:00.000Z',
                amount: 262500,
                inputType: 'DOLLAR',
              },
              {
                paymentDate: '2026-01-30T12:00:00.000Z',
                amount: 300000,
                inputType: 'DOLLAR',
              },
            ],
            createdAt: '2025-06-21T10:30:00.000Z',
          },
        ],
      },
    ],
    issuerTenantIds: ['issuer-tenant-1'],
    status: ProposalStatus.COMPLETED,
    files: [{ id: 'msw-file-003', name: 'final-agreement.pdf' }],
    createdAt: '2025-06-05T14:20:00.000Z',
  },
]

export const mockBuyerProposals: BuyerProposalDetailDto[] = [
  {
    proposalId: 'test-uuid-123',
    fund: 'Test Fund',
    depositAmount: 1000000,
    depositDate: '2025-01-10T12:00:00.000Z',
    bidDeadline: '2025-01-05T12:00:00.000Z',
    scheduleType: ScheduleType.DEPOSIT,
    scenarios: [
      {
        id: 'scenario-1',
        proposedRate: 3.4,
        wamYears: 5,
        paymentSchedule: [
          {
            payoutAmount: 0,
            payoutPercentage: 50,
            paymentDate: '2025-03-15T12:00:00.000Z',
          },
          {
            payoutAmount: 0,
            payoutPercentage: 50,
            paymentDate: '2025-07-20T12:00:00.000Z',
          },
        ],
        bids: [
          {
            id: 'bid-1',
            issuerTenantId: 'tenant-1-id',
            rate: 3.45,
            treasuryRate: 3.2,
            notes: null,
            status: null,
            createdAt: '2025-01-05T08:45:00.000Z',
          },
          {
            id: 'bid-2',
            issuerTenantId: 'tenant-2-id',
            rate: 3.35,
            treasuryRate: 3.1,
            notes: 'Notes on bid 2',
            status: null,
            createdAt: '2025-01-05T09:12:00.000Z',
          },
        ],
        selectedBids: [],
      },
      {
        id: 'scenario-2',
        proposedRate: 4.2,
        wamYears: 7.5,
        paymentSchedule: [
          {
            payoutAmount: 0,
            payoutPercentage: 30,
            paymentDate: '2025-04-01T12:00:00.000Z',
          },
          {
            payoutAmount: 0,
            payoutPercentage: 30,
            paymentDate: '2025-08-01T12:00:00.000Z',
          },
          {
            payoutAmount: 0,
            payoutPercentage: 40,
            paymentDate: '2025-12-15T12:00:00.000Z',
          },
        ],
        bids: [],
        selectedBids: [],
      },
      {
        id: 'scenario-3',
        proposedRate: 3.25,
        wamYears: 3,
        paymentSchedule: [
          {
            payoutAmount: 0,
            payoutPercentage: 100,
            paymentDate: '2025-05-30T12:00:00.000Z',
          },
        ],
        bids: [
          {
            id: 'bid-3',
            issuerTenantId: 'tenant-2-id',
            rate: 3.25,
            treasuryRate: 3.1,
            notes: null,
            status: null,
            createdAt: '2025-01-05T09:12:00.000Z',
          },
        ],
        selectedBids: [],
      },
    ],
    issuerTenantIds: ['tenant-1-id', 'tenant-2-id'],
    status: ProposalStatus.ACTIVE,
    files: [
      { id: 'file-123', name: 'proposal-overview.pdf' },
      { id: 'file-456', name: 'financial-terms.docx' },
    ],
    createdAt: '2025-01-01T12:00:00.000Z',
  },
  {
    proposalId: 'test-uuid-456',
    fund: 'Another Fund',
    depositAmount: 2500000,
    depositDate: '2025-02-10T06:00:00.000Z',
    bidDeadline: '2025-02-05T06:00:00.000Z',
    scheduleType: ScheduleType.DEPOSIT,
    scenarios: [
      {
        id: 'scenario-4',
        proposedRate: 3.75,
        wamYears: 4.25,
        paymentSchedule: [
          {
            payoutAmount: 0,
            payoutPercentage: 100,
            paymentDate: '2025-05-15T06:00:00.000Z',
          },
        ],
        bids: [
          {
            id: 'bid-4',
            issuerTenantId: 'issuer-1-id',
            rate: 3.755,
            treasuryRate: 3.1,
            notes: 'Notes on bid 4',
            status: null,
            createdAt: '2025-01-06T09:13:00.000Z',
          },
        ],
        selectedBids: [
          {
            selectedBidId: 'selected-bid-1-id',
            issuerTenantId: 'issuer-1-id',
            rate: 3.766,
            treasuryRate: 3.2,
            amount: 2200000,
            wamYears: 4.25,
            partialMaturities: [
              {
                paymentDate: '2025-05-15T06:00:00.000Z',
                amount: 2200000,
                inputType: 'DOLLAR',
              },
            ],
            createdAt: '2025-01-06T11:04:00.000Z',
          },
        ],
      },
    ],
    issuerTenantIds: ['issuer-1-id', 'issuer-2-id'],
    status: ProposalStatus.COMPLETED,
    files: [
      { id: 'file-789', name: 'contract-terms.pdf' },
      { id: 'file-101', name: 'final-agreement.pdf' },
    ],
    createdAt: '2025-01-02T06:00:00.000Z',
  },
]

export const mockFileTypes: FileType[] = [
  {
    mimeType: 'application/pdf',
    extensions: ['.pdf'],
  },
  {
    mimeType: 'application/msword',
    extensions: ['.doc', '.docx'],
  },
]

export const handlers = [
  // Create a new proposal
  http.post<never, CreateProposalDto, ProposalCreationResponse>(
    '**/proposals',
    async ({ request }) => {
      const proposalData = await request.json()
      const newProposal: BuyerProposalDetailDto = {
        ...proposalData,
        proposalId: uuidv4(),
        status: ProposalStatus.ACTIVE,
        files: proposalData.files ?? [],
        scenarios: proposalData.scenarios ?? [],
        createdAt: new Date().toISOString(),
        bidDeadlineTimezone: proposalData.bidDeadlineTimezone ?? null,
        issuerTenantIds: proposalData.issuerTenantIds ?? [],
      }

      mockBuyerProposals.push(newProposal)
      return HttpResponse.json({ proposalId: newProposal.proposalId })
    }
  ),

  // Get buyer proposals
  http.get('**/proposals/buyer', () => {
    return HttpResponse.json([...mockBuyerProposals])
  }),

  // Get buyer proposal details
  http.get('**/proposals/buyer/:proposalId', ({ params }) => {
    const proposal = mockBuyerProposals.find(
      (p) => p.proposalId === params.proposalId
    )
    return HttpResponse.json(proposal)
  }),

  // Get issuer proposal overviews
  http.get('**/proposals/issuer', () => {
    return HttpResponse.json(mswMockIssuerProposalOverviews)
  }),

  // Get issuer proposal details
  http.get('**/proposals/issuer/:proposalId', ({ params }) => {
    const proposal = mockIssuerProposals.find((p) => p.id === params.proposalId)
    return HttpResponse.json(proposal)
  }),

  // Update proposal status
  http.put<{ proposalId: string; status: string }, never, boolean>(
    '**/proposals/buyer/:proposalId/status/:status',
    ({ params }) => {
      const proposal = mockBuyerProposals.find(
        (p) => p.proposalId === params.proposalId
      )

      if (proposal != null) {
        // Convert string status to ProposalStatus enum
        proposal.status = params.status as ProposalStatus
        return HttpResponse.json(true)
      }

      return new HttpResponse(null, { status: 404 })
    }
  ),

  // Upload file
  http.post<never, FormData, FileUploadResponse>(
    '**/proposals/files/upload',
    () => {
      return HttpResponse.json({
        success: true,
        fileId: `file-${uuidv4()}`,
        fileName: 'test-file.pdf',
      })
    }
  ),

  // Delete file
  http.delete<{ fileId: string }, never, boolean>(
    '**/proposals/files/:fileId',
    () => {
      return HttpResponse.json(true)
    }
  ),

  // Get accepted file types
  http.get('**/proposals/files/types', () => {
    return HttpResponse.json([...mockFileTypes])
  }),
]
